<template>
  <template
    v-for="componentJson in markupComponents"
    :key="componentJson.generatedId"
  >
    <MarkupPhoneListingPageTemplate
      v-if="
        componentJson.Component.toLowerCase() === TEMPLATE_PHONE_LISTING_PAGE
      "
      :config-data="componentJson"
    />

    <MarkupPhoneManufacturerPageTemplate
      v-if="
        componentJson.Component.toLowerCase() ===
        TEMPLATE_PHONE_MANUFACTURER_PAGE
      "
      :config-data="componentJson"
    />

    <MarkupAccessoryListingPageTemplate
      v-if="
        componentJson.Component.toLowerCase() ===
        TEMPLATE_ACCESSORY_LISTING_PAGE
      "
      :config-data="componentJson"
    />

    <MarkupUsedListingPageTemplate
      v-if="
        componentJson.Component.toLowerCase() === TEMPLATE_USED_LISTING_PAGE
      "
      :config-data="componentJson"
    />

    <MarkupProductPageTemplate
      v-if="componentJson.Component.toLowerCase() === TEMPLATE_PRODUCT_PAGE"
      :config-data="componentJson"
    />

    <MarkupBanner
      v-if="componentJson.Component.toLowerCase() === COMPONENT_BANNER"
      :config-data="componentJson"
    />

    <MarkupCampaignLabelWrapper
      v-else-if="
        componentJson.Component.toLowerCase() === COMPONENT_CAMPAING_LABEL
      "
      :config-data="componentJson"
    />

    <MarkupMarginSpace
      v-else-if="componentJson.Component.toLowerCase() === COMPONENT_MARGIN"
      :config-data="componentJson"
    />
    <MarkupGeneratorCommon
      v-else
      :config-data="componentJson"
      :is-page="isPage"
    >
      <MarkupSectionHeaderH1
        v-if="componentJson.Component.toLowerCase() === COMPONENT_H1_HEADER"
        :config-data="componentJson"
      />

      <MarkupSectionHeader
        v-if="componentJson.Component.toLowerCase() === COMPONENT_HEADER"
        :config-data="componentJson"
      />

      <MarkupSectionText
        v-if="componentJson.Component.toLowerCase() === COMPONENT_TEXT"
        :config-data="componentJson"
      />

      <MarkupUspWrapper
        v-if="componentJson.Component.toLowerCase() === COMPONENT_USP"
        :config-data="componentJson"
      />

      <MarkupFamilyDrawer
        v-if="componentJson.Component.toLowerCase() === COMPONENT_FAMILY_DRAWER"
        :config-data="componentJson"
      />

      <MarkupFamilySubscriptionButton
        v-if="
          componentJson.Component.toLowerCase() ===
          COMPONENT_FAMILY_SUBSCRIPTION_BUTTON
        "
        :config-data="componentJson"
      />

      <MarkupFilterSection
        v-if="
          componentJson.Component.toLowerCase() === COMPONENT_FILTER_SECTION
        "
        :config-data="componentJson"
      />

      <MarkupPostPaidCardListingWrapper
        v-if="
          componentJson.Component.toLowerCase() === COMPONENT_SUBSCRIPTION_LIST
        "
        :config-data="componentJson"
      />

      <MarkupProductCardListingWrapper
        v-if="componentJson.Component.toLowerCase() === COMPONENT_PRODUCT_LIST"
        :config-data="componentJson"
        :standalone="isStandaloneProductList(componentJson)"
      />

      <MarkupLinkAndTextWrapper
        v-if="componentJson.Component.toLowerCase() === COMPONENT_LINK_AND_TEXT"
        :config-data="componentJson"
      />

      <MarkupHeroWrapper
        v-if="componentJson.Component.toLowerCase() === COMPONENT_HERO"
        :config-data="componentJson"
      />

      <MarkupCardSliderWrapper
        v-if="
          componentJson.Component.toLowerCase() ===
          COMPONENT_PRODUCT_SLIDER_BY_CATEGORY
        "
        :config-data="componentJson"
      />

      <MarkupAccordionWrapper
        v-if="
          componentJson.Component.toLowerCase() === COMPONENT_ACCORDION_START
        "
        :config-data="componentJson"
      />

      <MarkupLayoutAlignCenter
        v-if="
          componentJson.Component.toLowerCase() === COMPONENT_ALIGNCENTER_START
        "
        :config-data="componentJson"
      />

      <MarkupDrawer
        v-if="componentJson.Component.toLowerCase() === COMPONENT_DRAWER_START"
        :config-data="componentJson"
      />

      <MarkupLayoutTwoColumn
        v-if="
          componentJson.Component.toLowerCase() ===
          COMPONENT_LAYOUT_TWO_COLUMN_START
        "
        :config-data="componentJson"
      />

      <MarkupLayoutTwoColumnInner
        v-if="
          componentJson.Component.toLowerCase() ===
          COMPONENT_LAYOUT_TWO_COLUMN_INNER_START
        "
        :config-data="componentJson"
      />

      <MarkupNotificationWrapper
        v-if="componentJson.Component.toLowerCase() === COMPONENT_NOTIFICATION"
        :config-data="componentJson"
      />

      <MarkupFaqWrapper
        v-if="componentJson.Component.toLowerCase() === COMPONENT_FAQ"
        :config-data="componentJson"
      />

      <MarkupSimpleHeaderText
        v-if="
          componentJson.Component.toLowerCase() === COMPONENT_SIMPLE_HEADER_TEXT
        "
        :config-data="componentJson"
      />

      <MarkupSimpleBulletList
        v-if="
          componentJson.Component.toLowerCase() === COMPONENT_SIMPLE_BULLET_LIST
        "
        :config-data="componentJson"
      />

      <MarkupLinkWrapper
        v-if="componentJson.Component.toLowerCase() === COMPONENT_SIMPLE_LINK"
        :config-data="componentJson"
      />

      <MarkupSimpleImage
        v-if="componentJson.Component.toLowerCase() === COMPONENT_SIMPLE_IMAGE"
        :config-data="componentJson"
      />

      <MarkupContentBlockWrapper
        v-if="componentJson.Component.toLowerCase() === COMPONENT_CONTENT_BLOCK"
        :config-data="componentJson"
      />

      <MarkupValuateOnlyBuybackWrapper
        v-if="
          componentJson.Component.toLowerCase() ===
          COMPONENT_VALUATE_ONLY_BUYBACK
        "
        :config-data="componentJson"
      />

      <MarkupPrePaidPlans
        v-if="
          componentJson.Component.toLowerCase() === COMPONENT_PRE_PAID_PLANS
        "
        :config-data="componentJson"
      />

      <MarkupPopup
        v-if="componentJson.Component.toLowerCase() === COMPONENT_POPUP"
        :config-data="componentJson"
      />
      <MarkupEmbeddedVideo
        v-if="
          componentJson.Component.toLowerCase() === COMPONENT_EMBEDDED_VIDEO
        "
        :config-data="componentJson"
      />
    </MarkupGeneratorCommon>

    <MarkupSeasonalDealsCardsWrapper
      v-if="
        componentJson.Component.toLowerCase() ===
        COMPONENT_SEASONAL_DEALS_PRODUCT_CARDS
      "
      variant="product"
      :config-data="componentJson"
    />

    <MarkupSeasonalDealsCardsWrapper
      v-if="
        componentJson.Component.toLowerCase() ===
        COMPONENT_SEASONAL_DEALS_SUBSCRIPTION_CARDS
      "
      variant="subscription"
      :config-data="componentJson"
    />

    <MarkupCTALinkCardsWrapper
      v-if="componentJson.Component.toLowerCase() === COMPONENT_CTA_LINK_CARDS"
      :config-data="componentJson"
    />
  </template>
</template>

<script setup lang="ts">
import { MarkupEmbeddedVideo } from '#components';
import { useMarkupComponents } from '~/composables/general/useMarkupComponents';
import type { MarkupData } from '~/repository/modules/category.module';
import {
  TEMPLATE_PHONE_LISTING_PAGE,
  TEMPLATE_PHONE_MANUFACTURER_PAGE,
  TEMPLATE_ACCESSORY_LISTING_PAGE,
  TEMPLATE_USED_LISTING_PAGE,
  TEMPLATE_PRODUCT_PAGE,
  COMPONENT_H1_HEADER,
  COMPONENT_HEADER,
  COMPONENT_TEXT,
  COMPONENT_USP,
  COMPONENT_HERO,
  COMPONENT_LINK_AND_TEXT,
  COMPONENT_FAMILY_SUBSCRIPTION_BUTTON,
  COMPONENT_FAMILY_DRAWER,
  COMPONENT_FILTER_SECTION,
  COMPONENT_PRODUCT_LIST,
  COMPONENT_SUBSCRIPTION_LIST,
  COMPONENT_PRODUCT_SLIDER_BY_CATEGORY,
  COMPONENT_NOTIFICATION,
  COMPONENT_FAQ,
  COMPONENT_ACCORDION_START,
  COMPONENT_ALIGNCENTER_START,
  COMPONENT_DRAWER_START,
  COMPONENT_LAYOUT_TWO_COLUMN_START,
  COMPONENT_LAYOUT_TWO_COLUMN_INNER_START,
  COMPONENT_BANNER,
  COMPONENT_SIMPLE_HEADER_TEXT,
  COMPONENT_SIMPLE_BULLET_LIST,
  COMPONENT_SIMPLE_LINK,
  COMPONENT_MARGIN,
  COMPONENT_SIMPLE_IMAGE,
  COMPONENT_POPUP,
  COMPONENT_CAMPAING_LABEL,
  COMPONENT_PRE_PAID_DATA,
  COMPONENT_PRE_PAID_PLANS,
  COMPONENT_CONTENT_BLOCK,
  COMPONENT_VALUATE_ONLY_BUYBACK,
  COMPONENT_EMBEDDED_VIDEO,
  COMPONENT_SEASONAL_DEALS_PRODUCT_CARDS,
  COMPONENT_SEASONAL_DEALS_SUBSCRIPTION_CARDS,
  COMPONENT_CTA_LINK_CARDS,
} from '~/models/MarkupComponentNames.model';
import { useDetermineStandaloneProductList } from '~/composables/useDetermineStandaloneProductList';

interface Props {
  pageData?: MarkupData | null;
  uriEncodedPageString?: string | '';
  isPage: boolean | true;
}

const props = defineProps<Props>();

const bannerStore = useBannerStore();
bannerStore.clear();

// Put id's for the render loop
// Needs to be at top level in component
if (props.pageData?.PageContent) {
  for (const comp of props.pageData.PageContent) {
    comp.generatedId = `component-${useId()}`;
  }
}

const { processedMarkupComponents } = useMarkupComponents(props.pageData);

// WIP
//const secondary = decodeURIComponent(atob(props.uriEncodedPageString || ''));
//const concatinated =
//  (props.pageData?.PageContent || '') + ((secondary && secondary) || '');
// const parsedComponents =
//  (concatinated && parseTextAsMarkup(concatinated)) || [];

const markupComponents = processedMarkupComponents;

const { isStandaloneProductList } =
  useDetermineStandaloneProductList(markupComponents);

const prePaidData = markupComponents.value.filter(
  (component) => component.Component.toLowerCase() === COMPONENT_PRE_PAID_DATA,
);

if (prePaidData) {
  const prePaidStore = usePrePaidStore();
  for (let i = 0; i < prePaidData.length; i++) {
    prePaidStore.setPrePaidPlans(
      prePaidData[i].Data,
      prePaidData[i].PlanGroupId,
    );
  }
}
</script>

<style scoped lang="scss"></style>
